
define('template!ordersUnpaidTotalsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tiles">\n  ';
 if(!loaded) { ;
__p += '\n    <div class="loading">' +
((__t = ( _.i18n('common.loading', null, 'Loading…') )) == null ? '' : __t) +
'</div>\n  ';
 } ;
__p += '\n  ';
 _.each(tiles, function(tile) { ;
__p += '\n    <div class="tile ' +
((__t = ( tile.className )) == null ? '' : __t) +
' ' +
((__t = ( tile.selected ? 'selected' : '' )) == null ? '' : __t) +
'" data-bucket="' +
__e( tile.bucket ) +
'">\n      <div class="tile-label">' +
__e( tile.label ) +
'</div>\n      <div class="tile-val">' +
__e( tile.amount ) +
'</div>\n      <div class="tile-sub">' +
__e( tile.count ) +
' ' +
((__t = ( _.i18n('unpaidOrders.aging.orders', null, 'orders') )) == null ? '' : __t) +
'</div>\n    </div>\n  ';
 }); ;
__p += '\n</div>\n';

}
return __p
};});

